import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { Button } from "../components/ui/button";
import { Field, FieldError, FieldLabel } from "../components/ui/field";
import { Input } from "../components/ui/input";
import { DocumentEditor } from "../knowledge/DocumentEditor";
import { createCustomerContextItem } from "./api";

type AddFormProps = { organizationId: string; onAdded: () => void };

export function AddContextItem({ organizationId, onAdded }: AddFormProps) {
  const queryClient = useQueryClient();
  const [title, setTitle] = useState("");
  const [bodyText, setBodyText] = useState("");
  const mutation = useMutation({
    mutationFn: () =>
      createCustomerContextItem(organizationId, {
        kind: "note",
        title,
        bodyText: bodyText || null,
        toolId: null,
        metadata: { bodyFormat: "markdown" },
        sourceCreatedAt: null,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["ops", "context", organizationId] });
      onAdded();
    },
  });
  return (
    <form
      className="space-y-2"
      onSubmit={(event) => {
        event.preventDefault();
        mutation.mutate();
      }}
    >
      <Field>
        <FieldLabel htmlFor="context-title">Context title</FieldLabel>
        <Input
          id="context-title"
          value={title}
          onChange={(event) => {
            setTitle(event.target.value);
          }}
          required
        />
      </Field>
      <DocumentEditor markdown={bodyText} onChange={setBodyText} />
      <p className="text-xs text-muted-foreground">
        {bodyText.length.toLocaleString()} / 20,000 characters
      </p>
      {mutation.error ? <FieldError>{mutation.error.message}</FieldError> : null}
      <Button type="submit" disabled={mutation.isPending || bodyText.length > 20_000}>
        Add context
      </Button>
    </form>
  );
}
